import { Box } from '@material-ui/core'
import { BaseWidget } from './base'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { Button } from 'react-admin'
import Pill from '../pill'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  consultBtn: {
    '& .MuiButton-startIcon': {
      marginLeft: '0',
      marginRight: '0',
    },
  },
}))

export const WidgetTicketKPI = (props) => {
  const classes = useStyles()

  return (
    <Grid container spacing={3}>
      {props.processes.map((process) => (
        <BaseWidget props={{ ...props, ...process }}>
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              Demandes à traiter
            </Typography>
            <Pill
              id={process.id}
              value={process.nb_draft_tickets}
              status={process.nb_draft_tickets === 0 ? 'success' : 'error'}
              size="small"
            />
          </Box>
          {/* <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              Dossiers en cours
            </Typography>
            <Pill
              id={process.id}
              value={process.nb_active_tickets}
              status="success"
              size="small"
            />
          </Box> */}
          {/*<Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              Dossiers deadline dépassée
            </Typography>
            <Pill
              id={process.id}
              value={process.nb_overdue_tickets}
              status="success"
              size="small"
            />
          </Box>*/}
          <Box display="flex" p={0.5} justifyContent="space-between">
            <Typography variant="body2" align="left">
              Dossiers deadline &lt; t+5j
            </Typography>
            <Pill
              id={process.id}
              value={process.nb_soon_overdue_tickets}
              status="success"
              size="small"
            />
          </Box>
          <br />
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to={{
              pathname: '/tickets',
              search: `filter=${JSON.stringify({ process_id: process.id })}`,
            }}
            disableElevation
            className={classes.consultBtn}
          >
            Consulter
          </Button>
        </BaseWidget>
      ))}
    </Grid>
  )
}
